
import { getRequest } from '../api/apiService';

export const fetchAllActivities = async () => {
    try {
        const response = await getRequest('/api/activities');
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const fetchEntityHistory = async (entityType, entityId) => {
    try {
        const response = await getRequest(`/api/activities/${entityType}/${entityId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};
